import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  showCustomToast,
  CustomToastContainer,
} from "../../components/CustomToast";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from 'react-router-dom';

const User_domicile = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [files, setFiles] = useState({});
  const [showDocument, setShowDocument] = useState();
  const statusEnum = ["In-Progress", "Submitted", "Rejected", "Completed"];
  const navigate = useNavigate(); // Use navigate to redirect

  const [licenseData, setLicenseData] = useState({
    fullName: "",
    fullNameMarathi: "",
    fatherFullNameEnglish: "",
    fatherFullNameMarathi: "",
    dateOfBirth: "",
    age: "",
    gender: "Male", // Set default value if needed
    mobileNumber: "",
    occupation: "",
    address: "",
    district: "",
    tahsil: "",
    residingAddressSince: "",
    benificiaryRelation: "",
    benificiaryFullName: "",
    benificiaryDOB: "",
    benificiaryMobileNumber: "",
    benificiaryEducation: "",
    benificiaryUniversity: "",
    benificiaryAdmissionYear: "",
    benificiaryCompelitionYear: "", // Changed to an empty string
    reasonOfDomicile: "", // Changed to an empty string
    rejectedNote: "",
    submitNote: "",
    completedNote: "",
    rejectedAt: "",
    submitedAt: "", // Fixed typo from "submitedAt"
    CompletedAt: "", // Fixed typo from "CompletedAt"
  });

  const [documents, setDocuments] = useState({
    aadharCardSon: null,
    aadharCardFather: null,
    schoolLCSon: null,
    schoolLCFather: null,
    photo: null,
    rationCard: null,
    lightBill: null,
    MSEBBonafide: null,
    receipt: null,
    finisheddoc: null,
  });

  useEffect(() => {
    const fetchLicenseData = async () => {
      try {
        const response = await axios.get(
          `https://api.makeeasydocuments.com/api/domicileCertificate/getbyiddomicile-certificate/${id}`
        );
        setLicenseData(response.data);
      } catch (err) {
        setError("Error fetching license data", 'error');
      } finally {
        setLoading(false);
      }
    };

    fetchLicenseData();
  }, [id]);


  console.log("license Data", licenseData)

  const handleUpdate = async (event) => {
    event.preventDefault();

    // Update the status to "In-Progress"
    const updatedLicenseData = { ...licenseData, Status: "In-Progress" };
    const formData = new FormData();

    for (const key in updatedLicenseData) {
      if (updatedLicenseData.hasOwnProperty(key)) {
        // Skip the documents and user objects
        if (key !== 'documents' && key !== 'user') {
          // Handle dates specially
          if (updatedLicenseData[key] instanceof Date) {
            formData.append(key, updatedLicenseData[key].toISOString());
          }
          // Handle primitive values
          else if (typeof updatedLicenseData[key] !== 'object') {
            formData.append(key, updatedLicenseData[key]);
          }
        }
      }
    }

    // If you need to send the user ID, send it properly
    if (updatedLicenseData.user && updatedLicenseData.user._id) {
      formData.append('user', updatedLicenseData.user._id);
    }

    console.log("User Data:", licenseData.user);
    console.log("Updated Status:", updatedLicenseData.Status);

    // Append files to formData
    for (const [key, value] of Object.entries(files)) {
      if (value instanceof File) {
        formData.append(`documents.${key}`, value);
      }
    }

    // Log the FormData content for debugging
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }


    console.log("User Data:", licenseData.user);
    console.log("Updated Status:", updatedLicenseData.Status);

    // Append all fields from licenseData to formData
    formData.append("fullName", licenseData.fullName);
    formData.append("fullNameMarathi", licenseData.fullNameMarathi);
    formData.append("fatherFullNameEnglish", licenseData.fatherFullNameEnglish);
    formData.append("fatherFullNameMarathi", licenseData.fatherFullNameMarathi);
    formData.append("dateOfBirth", licenseData.dateOfBirth);
    formData.append("age", licenseData.age);
    formData.append("gender", licenseData.gender);
    formData.append("mobileNumber", licenseData.mobileNumber);
    formData.append("occupation", licenseData.occupation);
    formData.append("address", licenseData.address);
    formData.append("district", licenseData.district);
    formData.append("tahsil", licenseData.tahsil);
    formData.append("residingAddressSince", licenseData.residingAddressSince);
    formData.append("benificiaryRelation", licenseData.benificiaryRelation);
    formData.append("benificiaryFullName", licenseData.benificiaryFullName);
    formData.append("benificiaryDOB", licenseData.benificiaryDOB);
    formData.append("benificiaryMobileNumber", licenseData.benificiaryMobileNumber);
    formData.append("benificiaryEducation", licenseData.benificiaryEducation);
    formData.append("benificiaryUniversity", licenseData.benificiaryUniversity);
    formData.append("benificiaryAdmissionYear", licenseData.benificiaryAdmissionYear);
    formData.append("benificiaryCompelitionYear", licenseData.benificiaryCompelitionYear);
    formData.append("reasonOfDomicile", licenseData.reasonOfDomicile);
    formData.append("rejectedNote", licenseData.rejectedNote);
    formData.append("submitNote", licenseData.submitNote);
    formData.append("completedNote", licenseData.completedNote);
    formData.append("rejectedAt", licenseData.rejectedAt);
    formData.append("submitedAt", licenseData.submitedAt);
    formData.append("CompletedAt", licenseData.CompletedAt);
    formData.append("Status", updatedLicenseData.Status);


    try {
      const response = await axios.put(
        `https://api.makeeasydocuments.com/api/domicileCertificate/updatedomicile-certificate/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("response after update", response.data)
      showCustomToast(response.data.message);

      // Redirect after a successful update
      setTimeout(() => {
        window.location.href = "/dashboard/my_application"; // Redirect after 4 seconds
      }, 4001);
    } catch (error) {
      showCustomToast("Failed to update license.", 'error');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLicenseData({ ...licenseData, [name]: value });
  };

  const handleFileChange = (event) => {
    const { name, files } = event.target;
    setFiles((prevFiles) => ({
      ...prevFiles,
      [name]: files[0],
    }));
  };

  const renderImage = (imageData) => {
    try {
      // Check if all required properties exist and are valid
      if (
        imageData &&
        imageData.contentType &&
        imageData.data &&
        imageData.data.data &&
        Array.isArray(imageData.data.data)
      ) {
        const byteArray = new Uint8Array(imageData.data.data);
        const base64String = btoa(
          Array.from(byteArray)
            .map(byte => String.fromCharCode(byte))
            .join('')
        );
        return `data:${imageData.contentType};base64,${base64String}`;
      }
      console.log("Invalid image data:", imageData);
      return null;
    } catch (error) {
      console.error("Error rendering image:", error);
      return null;
    }
  };

  const DocumentPreviewModal = ({ document, onClose }) => {
    if (!document) return null;

    // Check if document is a string (URL) or an object
    const documentUrl = typeof document === 'string' ? document : null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-3xl w-full">
          <h2>Download The Documents From Here...</h2>

          {documentUrl && (
            <div className="my-4">
              <img
                src={documentUrl}
                className="max-w-full max-h-96 mx-auto"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = ""; // Placeholder for failed image load
                  // e.target.alt = "Unable to preview document";
                }}
              />
            </div>
          )}

          <div className="mt-4 flex justify-between">
            <button
              className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
              onClick={onClose}
            >
              Close
            </button>
            {documentUrl && (

              <a href={documentUrl}
                download
                className="bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700"
              >
                Download
              </a>
            )}
          </div>
        </div>
      </div>
    );
  };

  const DownloadableDocuments = () => {
    if (!licenseData?.documents) return null;

    const { receipt, finisheddoc } = licenseData.documents;

    if (!receipt && !finisheddoc) return null;

    return (
      <div className="col-span-3 bg-white shadow-md p-6 rounded-lg mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          Downloadable Documents
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {receipt && (
            <div className="border p-4 rounded-lg text-center bg-gray-50">
              <h3 className="font-semibold mb-2">Receipt</h3>
              <button
                className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
                onClick={() => {
                  const imageUrl = renderImage(receipt);
                  setShowDocument(imageUrl);
                }}
              >
                View Receipt
              </button>
            </div>
          )}
          {finisheddoc && (
            <div className="border p-4 rounded-lg text-center bg-gray-50">
              <h3 className="font-semibold mb-2">Finished Document</h3>
              <button
                className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
                onClick={() => setShowDocument(renderImage(finisheddoc))}
              >
                View Document
              </button>
            </div>
          )}
        </div>
      </div>
    );
  };

  if (loading) return <div className="text-center mt-10">Loading...</div>;
  if (error)
    return <div className="text-center mt-10 text-red-500">{error}</div>;
  if (!licenseData) return <div>No data found</div>;

  const labelClass = "block text-sm mb-2 font-medium text-gray-700";
  const inputClass = "border border-gray-300 rounded-md p-2 w-full";

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="bg-white shadow-xl rounded-lg overflow-hidden">
          <div className="px-4 py-5 sm:p-6">
            <h1 className="text-3xl font-bold text-center text-gray-900 mb-8">
              Domicile Certificate
            </h1>
            <DownloadableDocuments />
            <form onSubmit={handleUpdate} className="space-y-6">
              <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">

                <div>
                  <label htmlFor="application_type" className={labelClass}>
                    Application Type
                  </label>
                  <input
                    type="text"
                    id="application_type"
                    className={inputClass}
                    value={licenseData.application_type || ""}
                    onChange={handleInputChange}

                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                {/* Personal Information */}
                <div>
                  <label htmlFor="fullName" className={labelClass}>
                    Full Name
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    className={inputClass}
                    value={licenseData.fullName}
                    onChange={handleInputChange}
                    name='fullName'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>
                {/* Add other fields from the schema */}
                <div>
                  <label htmlFor="fatherFullNameEnglish" className={labelClass}>
                    Father's Full Name (English)
                  </label>
                  <input
                    type="text"
                    id="fatherFullNameEnglish"
                    className={inputClass}
                    value={licenseData.fatherFullNameEnglish || ""}
                    onChange={handleInputChange}
                    name="fatherFullNameEnglish"
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="fullNameMarathi" className={labelClass}>
                    Full Name (Marathi)
                  </label>
                  <input
                    type="text"
                    id="fullNameMarathi"
                    className={inputClass}
                    value={licenseData.fullNameMarathi || ""}
                    onChange={handleInputChange}
                    name='fullNameMarathi'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="fatherFullNameMarathi" className={labelClass}>
                    Father's Full Name (Marathi)
                  </label>
                  <input
                    type="text"
                    id="fatherFullNameMarathi"
                    className={inputClass}
                    value={licenseData.fatherFullNameMarathi || ""}
                    onChange={handleInputChange}
                    name='fatherFullNameMarathi'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="dateOfBirth" className={labelClass}>
                    Date of Birth
                  </label>
                  <input
                    type="date"
                    id="dateOfBirth"
                    className={inputClass}
                    value={licenseData.dateOfBirth || ""}
                    onChange={handleInputChange}
                    name='dateOfBirth'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="age" className={labelClass}>
                    Age
                  </label>
                  <input
                    type="text"
                    id="age"
                    className={inputClass}
                    value={licenseData.age || ""}
                    onChange={handleInputChange}
                    name='age'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="gender" className={labelClass}>
                    Gender
                  </label>
                  <select
                    id="gender"
                    className={inputClass}
                    value={licenseData.gender || ""}
                    onChange={handleInputChange}
                    name='gender'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="mobileNumber" className={labelClass}>
                    Mobile Number
                  </label>
                  <input
                    type="text"
                    id="mobileNumber"
                    className={inputClass}
                    value={licenseData.mobileNumber || ""}
                    onChange={handleInputChange}
                    name='mobileNumber'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="occupation" className={labelClass}>
                    Occupation
                  </label>
                  <input
                    type="text"
                    id="occupation"
                    className={inputClass}
                    value={licenseData.occupation || ""}
                    onChange={handleInputChange}
                    name='occupation'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="address" className={labelClass}>
                    Address
                  </label>
                  <input
                    type="text"
                    id="address"
                    className={inputClass}
                    value={licenseData.address || ""}
                    onChange={handleInputChange}
                    name='address'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="district" className={labelClass}>
                    District
                  </label>
                  <input
                    type="text"
                    id="district"
                    className={inputClass}
                    value={licenseData.district || ""}
                    onChange={handleInputChange}
                    name='district'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="tahsil" className={labelClass}>
                    Tahsil
                  </label>
                  <input
                    type="text"
                    id="tahsil"
                    className={inputClass}
                    value={licenseData.tahsil || ""}
                    onChange={handleInputChange}
                    name='tahsil'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="residingAddressSince" className={labelClass}>
                    Residing Address Since
                  </label>
                  <input
                    type="text"
                    id="residingAddressSince"
                    className={inputClass}
                    value={licenseData.residingAddressSince || ""}
                    onChange={handleInputChange}
                    name='residingAddressSince'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                {/* Beneficiary Information */}
                <div>
                  <label htmlFor="benificiaryRelation" className={labelClass}>
                    Beneficiary Relation
                  </label>
                  <input
                    type="text"
                    id="benificiaryRelation"
                    className={inputClass}
                    value={licenseData.benificiaryRelation || ""}
                    onChange={handleInputChange}
                    name='benificiaryRelation'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="benificiaryFullName" className={labelClass}>
                    Beneficiary Full Name
                  </label>
                  <input
                    type="text"
                    id="benificiaryFullName"
                    className={inputClass}
                    value={licenseData.benificiaryFullName || ""}
                    onChange={handleInputChange}
                    name='benificiaryFullName'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="benificiaryDOB" className={labelClass}>
                    Beneficiary Date of Birth
                  </label>
                  <input
                    type="date"
                    id="benificiaryDOB"
                    className={inputClass}
                    value={licenseData.benificiaryDOB || ""}
                    onChange={handleInputChange}
                    name='benificiaryDOB'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label
                    htmlFor="benificiaryMobileNumber"
                    className={labelClass}
                  >
                    Beneficiary Mobile Number
                  </label>
                  <input
                    type="text"
                    id="benificiaryMobileNumber"
                    className={inputClass}
                    value={licenseData.benificiaryMobileNumber || ""}
                    onChange={handleInputChange}
                    name='benificiaryMobileNumber'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="benificiaryEducation" className={labelClass}>
                    Beneficiary Education
                  </label>
                  <input
                    type="text"
                    id="benificiaryEducation"
                    className={inputClass}
                    value={licenseData.benificiaryEducation || ""}
                    onChange={handleInputChange}
                    name='benificiaryEducation'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="benificiaryUniversity" className={labelClass}>
                    Beneficiary University
                  </label>
                  <input
                    type="text"
                    id="benificiaryUniversity"
                    className={inputClass}
                    value={licenseData.benificiaryUniversity || ""}
                    onChange={handleInputChange}
                    name='benificiaryUniversity'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label
                    htmlFor="benificiaryAdmissionYear"
                    className={labelClass}
                  >
                    Beneficiary Admission Year
                  </label>
                  <input
                    type="text"
                    id="benificiaryAdmissionYear"
                    className={inputClass}
                    value={licenseData.benificiaryAdmissionYear || ""}
                    onChange={handleInputChange}
                    name='benificiaryAdmissionYear'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label
                    htmlFor="benificiaryCompelitionYear"
                    className={labelClass}
                  >
                    Beneficiary Completion Year
                  </label>
                  <input
                    type="text"
                    id="benificiaryCompelitionYear"
                    className={inputClass}
                    value={licenseData.benificiaryCompelitionYear || ""}
                    onChange={handleInputChange}
                    name='benificiaryCompelitionYear'
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="reasonOfDomicile" className={labelClass}>
                    Reason of Domicile
                  </label>
                  <input
                    type="text"
                    id="reasonOfDomicile"
                    className={inputClass}
                    value={licenseData.reasonOfDomicile || ""}
                    onChange={handleInputChange}
                    name='reasonOfDomicile'

                  />
                </div>

                {/* Document Uploads */}
                <div className="col-span-3">
                  <h2 className="text-xl font-semibold text-gray-900 mb-4">Documents</h2>

                  <div className="space-y-4">
                    {/* First Row */}
                    <div className="flex space-x-4">
                      <div className="flex-1">
                        <label className={labelClass} htmlFor="aadharCardSon">
                          Aadhar Card Son
                        </label>
                        <input
                          id="aadharCardSon"
                          name="aadharCardSon"
                          type="file"
                          className={inputClass}
                          accept="image/*"
                          onChange={handleFileChange}
                          disabled={licenseData.Status !== "Rejected"}
                        />
                      </div>

                      <div className="flex-1">
                        <label className={labelClass} htmlFor="aadharCardFather">
                          Aadhar Card Father
                        </label>
                        <input
                          id="aadharCardFather"
                          name="aadharCardFather"
                          type="file"
                          className={inputClass}
                          accept="image/*"
                          onChange={handleFileChange}
                          disabled={licenseData.Status !== "Rejected"}
                        />
                      </div>

                      <div className="flex-1">
                        <label className={labelClass} htmlFor="schoolLCSon">
                          School LC Son
                        </label>
                        <input
                          id="schoolLCSon"
                          name="schoolLCSon"
                          type="file"
                          className={inputClass}
                          accept="image/*"
                          onChange={handleFileChange}
                          disabled={licenseData.Status !== "Rejected"}
                        />
                      </div>
                    </div>

                    {/* Second Row */}
                    <div className="flex space-x-4">
                      <div className="flex-1">
                        <label className={labelClass} htmlFor="schoolLCFather">
                          School LC Father
                        </label>
                        <input
                          id="schoolLCFather"
                          name="schoolLCFather"
                          type="file"
                          className={inputClass}
                          accept="image/*"
                          onChange={handleFileChange}
                          disabled={licenseData.Status !== "Rejected"}
                        />
                      </div>

                      <div className="flex-1">
                        <label className={labelClass} htmlFor="photo">
                          Photo
                        </label>
                        <input
                          id="photo"
                          name="photo"
                          type="file"
                          className={inputClass}
                          accept="image/*"
                          onChange={handleFileChange}
                          disabled={licenseData.Status !== "Rejected"}
                        />
                      </div>

                      <div className="flex-1">
                        <label className={labelClass} htmlFor="rationCard">
                          Ration Card
                        </label>
                        <input
                          id="rationCard"
                          name="rationCard"
                          type="file"
                          className={inputClass}
                          accept="image/*"
                          onChange={handleFileChange}
                          disabled={licenseData.Status !== "Rejected"}
                        />
                      </div>
                    </div>

                    {/* Third Row */}
                    <div className="flex space-x-4">
                      <div className="flex-1">
                        <label className={labelClass} htmlFor="lightBill">
                          Light Bill
                        </label>
                        <input
                          id="lightBill"
                          name="lightBill"
                          type="file"
                          className={inputClass}
                          accept="image/*"
                          onChange={handleFileChange}
                          disabled={licenseData.Status !== "Rejected"}
                        />
                      </div>

                      <div className="flex-1">
                        <label className={labelClass} htmlFor="MSEBBonafide">
                          MSEB Bonafide
                        </label>
                        <input
                          id="MSEBBonafide"
                          name="MSEBBonafide"
                          type="file"
                          className={inputClass}
                          accept="image/*"
                          onChange={handleFileChange}
                          disabled={licenseData.Status !== "Rejected"}
                        />
                      </div>

                      
                    </div>

                   
                    
                  </div>
                </div>


                {/* Application History */}
                <div className="col-span-3 bg-green-50 shadow-md p-6 rounded-lg w-full space-y-4">
                  <h2 className="text-xl text-center font-bold mb-4 text-gray-700 border-b-2 border-gray-400 pb-2">
                    Application History
                  </h2>

                  <div className="flex justify-between text-gray-800">
                    <strong className="text-gray-600 flex-1">
                      Created At (Date & Time):
                    </strong>
                    <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                      {new Date(licenseData.createdAt).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                      })}
                    </span>
                  </div>

                  <div className="flex justify-between text-gray-800">
                    <strong className="text-gray-600 flex-1">
                      Updated At (Date & Time):
                    </strong>
                    <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                      {licenseData.updatedAt
                        ? new Date(licenseData.updatedAt).toLocaleString(
                          "en-IN",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                          }
                        )
                        : "N/A"}
                    </span>
                  </div>
                  <div className="flex justify-between text-gray-800">
                    <strong className="text-gray-600 flex-1">Current Status:</strong>
                    <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                      {licenseData.Status ? licenseData.Status : 'N/A'}
                    </span>
                  </div>

                  {/* history */}
                  {/* Display history regardless of Status */}
                  <div className="flex justify-between text-gray-800">
                    <div className="text-gray-600 flex-1">
                      <strong className="text-gray-600">Status History:</strong>
                    </div>

                    {/* Display for new schema with statusHistory */}
                    {licenseData.statusHistory && licenseData.statusHistory.length > 0 ? (
                      <div className="flex-1 text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                        {licenseData.statusHistory.map((statusChange, index) => (
                          <div
                            key={index}
                            className={`p-3 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} border-b border-gray-300 last:border-b-0`}
                          >
                            <div className="flex justify-between items-center mb-1">
                              <span className="text-sm font-medium text-gray-500">
                                Changed on: {new Date(statusChange.changedAt).toLocaleString()}
                              </span>
                              <span className={`text-xs font-semibold px-2 py-1 rounded ${statusChange.status === 'Rejected' ? 'bg-red-100 text-red-800' :
                                statusChange.status === 'Submitted' ? 'bg-blue-100 text-blue-800' :
                                  statusChange.status === 'Completed' ? 'bg-green-100 text-green-800' :
                                    'bg-yellow-100 text-yellow-800'
                                }`}>
                                {statusChange.status}
                              </span>
                            </div>
                            <p className="text-gray-700">{statusChange.note || "No additional notes"}</p>
                          </div>
                        ))}
                      </div>
                    ) : (
                      // Fallback for when no status history exists
                      <div className="text-center text-gray-500 border border-gray-300 bg-gray-50 p-3 rounded">
                        No status history available
                      </div>
                    )}
                  </div>
                </div>


                {licenseData.Status === "Rejected" && (
                  <div>
                    <button
                      type="submit"
                      className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
                    >
                      Update Application
                    </button>
                  </div>
                )}
              </div>
            </form>
            <DocumentPreviewModal
              document={showDocument}
              onClose={() => setShowDocument(null)}
            />

            <CustomToastContainer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default User_domicile;
